<template>
    <Modal
        v-model="modelIndex"
        @on-visible-change="haddleChangeModel"
        :closable="false"
        width="500"
        class="cbModel"
    >
        <div slot="header">
            <p class="p1">意见反馈</p>
            <p class="p2">感谢您对我们的支持，期待您宝贵的建议，我们会认真对待您的任何反馈。</p>
            <i class="iconfont" @click="modelIndex = false">&#xe6bb;</i>
        </div>
        <div>
            <Form ref="coupleBackForm" :model="coupleBackParams" :rules="ruleValidate">
                <FormItem prop="message">
                    <p class="tle">
                        <span>问题或建议</span>
                    </p>
                    <Input v-model="coupleBackParams.message" type="textarea" :rows="4" placeholder="请输入您的想法" />
                </FormItem>
                <FormItem prop="phone">
                    <p class="tle">
                        <span>联系方式</span>
                    </p>
                    <Input v-model="coupleBackParams.phone" placeholder="请输入您的联系电话，方便我们与您联系"/>
                </FormItem>
            </Form>
        </div>
        <div slot="footer">
            <!-- <p>如果有主动联系我们的需要，客服咨询:13627682184（微信同号）</p> -->
            <button @click="sumbitMessage">确定</button>
        </div>
    </Modal>
</template>

<script>
import { feedBack } from '../service'
export default {
  computed: {
    user_key() {
      return this.$store.state.user_key
    }
  },
  data () {
    return {
      modelIndex: false,
      coupleBackParams: {
        user_key: this.user_key,
        message: '',
        phone: '',
        type: '1'
      },
      ruleValidate: {
        'phone': [
          { required: true, message: '请输入您的联系电话', trigger: 'blur' },
          { type: 'number', message: '手机号格式不正确', trigger: 'blur', transform(value) {
              let reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                return false
              } else {
                return Number(value)
              }
            }
          }
        ],
        'message': { required: true, message: '请输入您的想法', trigger: 'blur' }
      }
    }
  },
  props: ['cbModel'],
  methods: {
    sumbitMessage() {
      this.$refs['coupleBackForm'].validate(async (valid) => {
        if (valid) {
          let res = await feedBack(this.coupleBackParams, (error) => {
            this.$Message.error('请求失败！')
          })
          if (res.status == 'success') {
            this.modelIndex = false;
            this.$Message.success('提交成功！')
          } else {
            this.$Message.error(res.message)
          }
        }
      })
    },
    haddleChangeModel() {
      this.coupleBackParams = {
        user_key: this.user_key,
        message: '',
        phone: '',
        type: '1'
      }
      this.$emit('cbModelChange', this.modelIndex)
    }
  },
  watch: {
    cbModel(bl) {
      this.modelIndex = bl
    }
  }
}
</script>

<style lang="stylus" scoped>
.cbModel
  >>> .ivu-form-item-error-tip
    position: inherit
  >>>.ivu-modal-wrap
    display: flex
    align-items: center
  >>> .ivu-modal
    top: auto
    .ivu-modal-content
      border-radius: 0
      background-clip: initial
      .ivu-modal-header
        border-bottom: 0
        padding: 0
        background-image: url('~pic/couple_back_bg.png')
        background-size: 100%
        position: relative
        padding: 14px 24px
        p.p1
          line-height: 1
          font-size: 18px
          color: #FFFFFF
          font-weight: 600
        p.p2
          line-height: 1
          font-size: 12px
          color: #FFFFFF
          margin-top: 6px
          font-weight: normal
          height: auto
        .iconfont
          position: absolute
          font-size: 18px
          color: #fff
          right: 10px
          top: 10px
          cursor: pointer
      .ivu-modal-body
        padding: 20px 24px
        .ivu-form-item
          margin-bottom: 20px
          &:last-of-type
            margin-bottom: 0
        .tle
          line-height: 1
          font-size: 16px
          font-weight: 600
          span
            position: relative
            &:after
              content: '*'
              position: absolute
              top: 3px
              font-size: 18px
              right: -10px
              color: #E02020
        .ivu-input-wrapper
          margin-top: 10px
          textarea
            font-size: 14px
            border: 1px solid #DADCE2
            resize: none
            padding: 8px 10px
            cursor: auto
            &:focus
              box-shadow: none
          input
            font-size: 14px
            border: 1px solid #DADCE2
            height: 40px
            padding: 8px 10px
            cursor: auto
            &:focus
              box-shadow: none
      .ivu-modal-footer
        border-top: 0
        padding: 10px 0 24px
        text-align: center
        p
          color: #666
        button
          background: rgba(250, 122, 80, 1)
          color: #fff
          width: 120px
          height: 36px;
          border: 0
          font-size: 14px
          border-radius: 2px
          cursor: pointer
          &:hover
            background: #FC9C7C
</style>
